import { useEffect, useRef, type SetStateAction } from 'react';
import { useSetAtom, type WritableAtom } from 'jotai';

/** Preserve saved filters on entry, while applying deep links and explicit picker clears. */
export function useCatalogRouteFilter(
  enabled: boolean,
  routeId: string | undefined,
  selectionAtom: WritableAtom<string[] | undefined, [SetStateAction<string[] | undefined>], void>,
) {
  const setSelection = useSetAtom(selectionAtom);
  const previousRouteId = useRef(routeId);
  useEffect(() => {
    if (!enabled) {
      setSelection(undefined);
    } else if (routeId) {
      setSelection([routeId]);
    } else if (previousRouteId.current) {
      setSelection([]);
    }
    previousRouteId.current = routeId;
  }, [enabled, routeId, setSelection]);
}
